<template>
  <section style="height: 100vh">
    <v-tabs v-model="selectedTab" centered slider-color="yellow">
      <v-tab value="QUEUE"> Colas </v-tab>
      <v-tab value="EXTENSIONS"> Extensiones </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item>
        <status-queue :presetAxiosClient="axiosClient" :presetEndpoints="queueStatusEndpoints"></status-queue>
      </v-tab-item>
      <v-tab-item>
        <extension-status
          :presetAxiosClient="axiosClient"
          :presetEndpoints="extensionStatusEndpoints"
          wide
        ></extension-status>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
import StatusQueue from "@/components/Typifications/Queue/StatusQueue.vue";
import axios from "axios";
import ExtensionStatus from "@/components/Typifications/Extensions/ExtensionStatus.vue";

export default {
  components: { StatusQueue, ExtensionStatus },
  data() {
    return {
      isLoading: true,
      selectedTab: "QUEUE",
      axiosClient: null,
      queueStatusEndpoints: {
        getNewList: "/monitoring-link/manager/queue_new",
        getQueues: "/monitoring-link/clients/listQueue",
      },
      extensionStatusEndpoints: {
        getNewList: "/monitoring-link/manager/extension_new",
        getNewDetails: "/monitoring-link/manager/extension_new_details",
      },
    };
  },

  async created() {
    this.init();
  },

  methods: {
    async init() {
      if (!this.$route.query.token) {
        this.$router.push("/");
      } else {
        this.axiosClient = axios.create({
          baseURL: process.env.VUE_APP_ROOTAPI,
          headers: {
            "Access-Control-Allow-Origin": process.env.VUE_APP_ROOTAPI,
            Authorization: `Bearer ${this.$route.query.token}`,
          },
        });
      }

      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.border-toolbart {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}
</style>
